
import {
  defineComponent, nextTick, onMounted, ref, watch,
} from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    options: { type: Array, required: true },
    controlClass: { type: String, default: '' },
    filterable: { type: Boolean, default: false },
    propError: { type: String, default: '' },
    modelValue: { type: [String, Number] },
  },
  setup(props) {
    const mainStore = useMainStore();
    const { value, errorMessage } = useField(props.name);

    const selectRef = ref();

    function cancelReadOnly(onOff) {
      if (!props.filterable || !mainStore.isMobile) return;
      if (onOff) {
        nextTick(() => {
          const input = selectRef.value.$refs.selectWrapper.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          input.blur();
          input.focus();
        });
      }
    }
    watch(() => props.modelValue, () => {
      value.value = props.modelValue;
    });

    onMounted(() => {
      if (props.modelValue !== undefined) {
        value.value = props.modelValue;
      }
    });
    return {
      value,
      errorMessage,
      cancelReadOnly,
      selectRef,
    };
  },
});
